import Pusher, { Channel } from 'pusher-js';

import { getAuthToken } from '@/arise/api';
import { IS_DISCORD_ACTIVITY } from '@/globals';

const PUSHER_KEY = process.env.PUBLIC_PUSHER_KEY;
const PUSHER_CLUSTER = process.env.PUBLIC_PUSHER_CLUSTER;

const PUSHER_USERAUTH_ENDPOINT = IS_DISCORD_ACTIVITY
    ? '/.proxy/api/pusher/userAuth'
    : process.env.PUBLIC_ARISEENGINE_HOST + '/pusher/userAuth';
const PUSHER_CHANNELAUTH_ENDPOINT = IS_DISCORD_ACTIVITY
    ? '/.proxy/api/pusher/channelAuth'
    : process.env.PUBLIC_ARISEENGINE_HOST + '/pusher/channelAuth';

// Custom endpoints when using Discord Activity
const ADDITIONAL_CONFIG = IS_DISCORD_ACTIVITY
    ? {
          wsHost: window.location.host,
          wsPath: '/.proxy/pusher-ws',
          httpHost: window.location.host,
          httpPath: '/.proxy/pusher-http/pusher',
      }
    : {};
export class PusherService {
    private pusher: Pusher;
    private static instance: PusherService;

    private subscribedChannels: { [channelName: string]: Channel } = {};

    constructor() {
        this.pusher = new Pusher(PUSHER_KEY, {
            ...ADDITIONAL_CONFIG,
            cluster: PUSHER_CLUSTER,
            userAuthentication: {
                endpoint: PUSHER_USERAUTH_ENDPOINT,
                transport: 'ajax',
                params: {},
                headers: {
                    'X-Auth-Token': getAuthToken(),
                },
            },
            channelAuthorization: {
                endpoint: PUSHER_CHANNELAUTH_ENDPOINT,
                transport: 'ajax',
                headers: {
                    'X-Auth-Token': getAuthToken(),
                },
            },
        });
    }

    private static getInstance(): PusherService {
        if (!this.instance) {
            this.instance = new PusherService();
        }
        return this.instance;
    }

    public static subscribe(channelName: string): Channel {
        if (!getAuthToken()) return;
        const instance = this.getInstance();

        if (instance.subscribedChannels[channelName]) {
            return instance.subscribedChannels[channelName];
        }

        const p = instance.pusher;
        instance.subscribedChannels[channelName] = p.subscribe(channelName);
        return instance.subscribedChannels[channelName];
    }

    public static unsubscribe(channelName: string) {
        if (!getAuthToken()) return;
        const instance = this.getInstance();

        if (!instance.subscribedChannels[channelName]) {
            return;
        }

        const p = instance.pusher;
        p.unsubscribe(channelName);
        delete instance.subscribedChannels[channelName];
    }
}
